<div class="sc-radio-item"
  [id]="id"
  (click)="onClick($event)"
  [ngClass]="{
    'sc-radio-item--disabled': isDisabled || radioGroup.isDisabled,
    'sc-radio-item--readonly': isReadOnly || radioGroup.isReadOnly,
    'sc-radio-item--boxed': type == 'boxed',
    'sc-radio-item--boxed_checked': type == 'boxed' && isChecked(),
    'sc-radio-item--boxed_unselected': type == 'boxed' && !isChecked() && radioGroup && radioGroup.value
  }"
>
  <div class="sc-radio-item__circle">
    <div [ngClass]="{
      'sc-radio-item__circle-outer': type == 'default',
      'sc-radio-item__circle-outer--checked': type == 'default' && isChecked(),
      'sc-radio-item__circle-boxed': type == 'boxed',
      'sc-radio-item__circle-boxed--checked': type == 'boxed' && isChecked()
    }">
    </div>
    <div [ngClass]="{
        'sc-radio-item__circle-inner--checked': isChecked() && (type == 'default'),
        'sc-radio-item__circle-inner': type == 'default',
        'sc-radio-item__circle-inner-boxed': type == 'boxed' && isChecked()
      }">
    </div>
  </div>
  <input class="sc-radio-item__input" type="radio" [checked]="isChecked()" [disabled]="isDisabled || radioGroup.isDisabled"/>
  <label class="sc-radio-item__label" [ngClass]="{'sc-radio-item__label-boxed': type == 'boxed'}">
    <ng-content></ng-content>
  </label>
</div>